import React, { useMemo, useCallback } from "react";
import _ from "lodash";
import classNames from "classnames";
import {
  ButtonDisclosure,
  DropdownMenu,
  Dropdown,
  Button,
} from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";

import classes from "./BreadCrumb.scss";

/**
 * BreadCrumb component for navigating between standard sets
 */

const BLANK_ARRAY = [];
const BreadCrumb = ({
  standardSets = BLANK_ARRAY,
  selectedStandardSet = null,
  onStandardSetSelect = _.noop,
  testId = "select-learning-elements",
  currentSelectedStandardSet = null,
}) => {
  const { t } = useI18n(["common", "journal"]);

  const handleStandardSetSelect = option => {
    onStandardSetSelect({ option, currentSelectedStandardSet });
  };

  const resetSetSelection = useCallback(() => {
    onStandardSetSelect({ shouldCallOnSelect: false });
  }, [onStandardSetSelect]);
  const dropdownOptions = useMemo(
    () =>
      _.map(standardSets, set => ({
        key: set.id,
        label: set.label || set.title,
      })),
    [standardSets]
  );

  return (
    <div className={classes.standardSetSelection}>
      <Button
        type="inline"
        variant="neutral"
        size="small"
        className={classes.button}
        onClick={resetSetSelection}
      >
        {t("journal:standard_sets")}
      </Button>
      <span className={classes.separator}>/</span>
      <div className={classNames("text-body-s", classes.standardSelection)}>
        <Dropdown
          overlay={
            <DropdownMenu
              options={dropdownOptions}
              testId={testId}
              showSelection={true}
              onClick={handleStandardSetSelect}
              value={selectedStandardSet}
              isSearchEnabled={true}
              placeholder={t("common:search_for_a_with_label", {
                label: t("common:set"),
              })}
            />
          }
        >
          <ButtonDisclosure
            testId={`${testId}-setName`}
            type="inline"
            variant="progressive"
            size="small"
            className={classes.button}
          >
            {_.find(standardSets, set => set.id === selectedStandardSet)
              ?.label ||
              _.find(standardSets, set => set.id === selectedStandardSet)
                ?.title ||
              t("journal:select_standard_set")}
          </ButtonDisclosure>
        </Dropdown>
      </div>
    </div>
  );
};

export default BreadCrumb;
